import React, { memo, useState } from 'react'
import styles from './CommonDateRangePicker.module.scss'
import { DateRangePicker, Range } from 'react-date-range';

type Props = {
    initialDateRange: Range
    onChange: (ranges: Range) => void
}

const CommonDateRangePicker: React.FC<Props> = memo((props: Props) => {
    const { initialDateRange, onChange } = props

    const [expanded, setExpanded] = useState(false)
    const [selectionRange, setSelectionRange] = useState<Range>(initialDateRange)

    function toggleExpanded() {
        setExpanded(!expanded)
    }

    function closeDatePicker(event: React.FocusEvent) {
        if (event.relatedTarget) return
        
        setExpanded(false)
    }

    return (
        <div className={styles.container} onBlur={closeDatePicker}>
            <button className={`standardButton ${styles.input}`} onClick={toggleExpanded} data-testid="date-range-toggle">
                <div className={styles.labelContainer}>
                    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.3077 19.5001C1.80257 19.5001 1.375 19.3251 1.025 18.9751C0.675 18.6251 0.5 18.1975 0.5 17.6924V4.30784C0.5 3.80271 0.675 3.37514 1.025 3.02514C1.375 2.67514 1.80257 2.50014 2.3077 2.50014H3.69233V1.15397C3.69233 0.934749 3.76573 0.751741 3.91253 0.604941C4.05931 0.458157 4.24232 0.384766 4.46155 0.384766C4.68077 0.384766 4.86378 0.458157 5.01058 0.604941C5.15736 0.751741 5.23075 0.934749 5.23075 1.15397V2.50014H12.8077V1.13474C12.8077 0.921925 12.8794 0.743724 13.023 0.60014C13.1666 0.456557 13.3448 0.384766 13.5576 0.384766C13.7704 0.384766 13.9486 0.456557 14.0922 0.60014C14.2358 0.743724 14.3076 0.921925 14.3076 1.13474V2.50014H15.6923C16.1974 2.50014 16.625 2.67514 16.975 3.02514C17.325 3.37514 17.5 3.80271 17.5 4.30784V17.6924C17.5 18.1975 17.325 18.6251 16.975 18.9751C16.625 19.3251 16.1974 19.5001 15.6923 19.5001H2.3077ZM2.3077 18.0001H15.6923C15.7692 18.0001 15.8397 17.9681 15.9038 17.904C15.9679 17.8398 16 17.7693 16 17.6924V8.30784H1.99997V17.6924C1.99997 17.7693 2.03202 17.8398 2.09612 17.904C2.16024 17.9681 2.23077 18.0001 2.3077 18.0001ZM1.99997 6.80787H16V4.30784C16 4.23091 15.9679 4.16038 15.9038 4.09627C15.8397 4.03217 15.7692 4.00012 15.6923 4.00012H2.3077C2.23077 4.00012 2.16024 4.03217 2.09612 4.09627C2.03202 4.16038 1.99997 4.23091 1.99997 4.30784V6.80787Z" fill="#2E3336" />
                    </svg>
                    Period
                </div>
                <div className={styles.valueContainer}>
                    {
                        `${selectionRange.startDate!.toLocaleDateString("en-gb")} - ${selectionRange.endDate!.toLocaleDateString("en-gb")}`
                    }
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.99595 5.75033C4.89595 5.75033 4.8022 5.73296 4.7147 5.69824C4.6272 5.66352 4.54873 5.61144 4.47928 5.54199L0.52799 1.5907C0.370517 1.43323 0.295253 1.2538 0.302198 1.05241C0.309142 0.85102 0.389003 0.673937 0.541781 0.521159C0.694559 0.368381 0.871642 0.291992 1.07303 0.291992C1.27442 0.291992 1.4515 0.368381 1.60428 0.521159L5.00011 3.93783L8.41678 0.521159C8.56956 0.368381 8.74664 0.295464 8.94803 0.302409C9.14942 0.309353 9.3265 0.389214 9.47928 0.541992C9.63206 0.69477 9.70845 0.871853 9.70845 1.07324C9.70845 1.27463 9.62971 1.45367 9.47224 1.61037L5.52095 5.54199C5.44595 5.61144 5.3647 5.66352 5.2772 5.69824C5.1897 5.73296 5.09595 5.75033 4.99595 5.75033Z" fill="#2E3336" />
                    </svg>

                </div>
            </button>
            <div className={`${styles.datePickerContainer} ${expanded ? styles.show : ''}`}
            >
                <DateRangePicker
                    ranges={[selectionRange]}
                    rangeColors={['#DE841B']}
                    onChange={(ranges) => {
                        setSelectionRange(ranges.selection)
                        onChange(ranges.selection)
                    }}
                />
            </div>
        </div>
    )
})

export default CommonDateRangePicker